<template>
  <el-dialog
    title="修改订单备注信息"
    :visible.sync="visible"
    width="480px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      label-width="50px"
      :rules="rules"
      :model="orderInfo">
      <el-form-item
        label="备注:"
        prop="remark">
        <el-input
          v-model="orderInfo.remark"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5}"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'OrderRemarkModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      orderInfo: {
        salesOrderId: null,
        remark: ''
      },
      rules: {
        remark: [{ required: false, message: '请输入订单标记', trigger: 'change' }]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() { },
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('outstock/salesremark', {
            payload: this.orderInfo,
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    fetch(options) {
      this.orderInfo = {
        ...this.orderInfo,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
